module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon_game.8398d.png";